import api from 'services/api/microfwk';
import _ from 'lodash';

/* TODO: Por ahora este servicio solo se ocupa compo helper,
 * En el proyecto se ocupa la función definida en
 * /src/react/requests/tasks/user/DeviceDetachTask.js
 */

export const detachDevice = (params = {}) =>
  api
    .get('/services/device/detach', {
      params,
    })
    .then(({ data }) => {
      const status = _.get(data, 'status', 0);
      if (parseInt(status, 10) === 200) return data.response;
      throw _.get(data, 'errors', 'Unhandled Error');
    })
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) throw data;
      throw error;
    });
